export default __webpack_public_path__ + "static/media/hotel-bg.98e35474.jpg";